import { Text } from '@thefarmersfront/kitchen';

import { DialogMessage } from '~/components/common';

const DialogAllUnCancelable = () => {
  return (
    <DialogMessage
      mainMessage={
        <>
          <Text size="large">{'요청 취소 불가한 상태입니다.\n취소 불가 조건:'}</Text>
          <div>
            <Text element="span" size="large" weight="semi-bold">
              [요청취소]{' '}
            </Text>
            <Text element="span" size="large">
              상태: 이미 요청이 취소된 경우
            </Text>
          </div>
          <div>
            <Text element="span" size="large" weight="semi-bold">
              [확인완료]{' '}
            </Text>
            <Text element="span" size="large">
              상태: 입고일 하루 전(D-1) 17시 이후
            </Text>
          </div>
        </>
      }
      captionMessage={
        <>
          <Text element="span" size="medium" weight="semi-bold" color="tertiary">
            [확인완료]
          </Text>
          <Text element="span" size="medium" color="tertiary">
            {'의 입고일 D-1일 17시 이후인 건에 대해\n취소하고자 하는 경우 컬리에 별도 문의해 주세요.'}
          </Text>
        </>
      }
    />
  );
};

export default DialogAllUnCancelable;
